// store this in a separate file, to avoid importing query client and axios in pixie

let activeWorkspaceId = 0;

/**
 * Lee `activeWorkspaceId` de la cookie del documento (misma fuente que el servidor).
 * El módulo `activeWorkspaceId` se sincroniza desde ActiveWorkspaceProvider en un effect;
 * entre renders, tras desmontajes o durante callbacks async (p. ej. fin de TUS), la cookie
 * es más fiable que el singleton en memoria.
 */
function readWorkspaceIdFromCookie(): number | null {
  if (typeof document === 'undefined') {
    return null;
  }
  const match = document.cookie.match(/(?:^|;\s*)activeWorkspaceId=([^;]*)/);
  if (!match) {
    return null;
  }
  const raw = decodeURIComponent(match[1]!.trim());
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : null;
}

/** Valor efectivo para API y metadatos de subida (cookie tiene prioridad en el navegador). */
export function getActiveWorkspaceId(): number {
  const fromCookie = readWorkspaceIdFromCookie();
  if (fromCookie !== null) {
    if (fromCookie !== activeWorkspaceId) {
      activeWorkspaceId = fromCookie;
    }
    return fromCookie;
  }
  return activeWorkspaceId;
}

export function setActiveWorkspaceId(id: number) {
  activeWorkspaceId = id;
}
